export const SUPPORT_STATUS_LABELS = {
  com_robo: 'Com Robo',
  em_disparo: 'Em Disparo',
  em_aberto: 'Em Aberto',
  visualizado: 'Visualizado',
  resolvido: 'Resolvido',
  ag_issue_correcao: 'Ag. Issue Correcao',
  ag_envio: 'Ag. Envio',
  enviado: 'Enviado',
  suspenso: 'Suspenso',
  pendente_retorno_cliente: 'Pendente Retorno Cliente',
  em_finalizacao: 'Em Finalizacao',
  encerrado: 'Encerrado',
  finalizado: 'Finalizado',
};

export const getSupportStatusLabel = (status, fallback = 'Sem status') => {
  if (!status) return fallback;
  return SUPPORT_STATUS_LABELS[status] || status;
};
